import Education from "./Education";
import Personal from "./Personal";
import Projects from "./Projects";
import Skills from "./Skills";

const Forms = {
    Education,
    Personal,
    Projects,
    Skills
};
export default Forms;